enum ActionTypes {
    SET_USER = "SET_USER",
    IS_DOCUMENT_COLLECTOR = "IS_DOCUMENT_COLLECTOR",
    IS_IDWAL_ADMIN = "IS_IDWAL_ADMIN",
    GET_INSPECTIONS = "GET_INSPECTIONS",
    GET_INSPECTION_BY_NUMBER = "GET_INSPECTIONS_BY_NUMBER",
    SET_SIDEBAR_DATA = "SET_SIDEBAR_DATA",
    UPLOAD_ASSET = "UPLOAD_ASSET",
    UPDATE_ASSET = "UPDATE_ASSET",
    DELETE_DOCUMENT = "DELETE_DOCUMENT",
    DELETE_IMAGE = "DELETE_IMAGE",
    DELETE_CHECKLIST = "DELETE_CHECKLIST",
    UPDATE_CHECKLIST = "UPDATE_CHECKLIST",
    UPDATE_COMPLETION_STATUS = "UPDATE_COMPLETION_STATUS",
    ADD_COMMENT = "ADD_COMMENT",
    UPDATE_UI_STATUS = "UPDATE_UI_STATUS",
    SET_IMAGE_DELETE_MODE = "SET_IMAGE_DELETE_MODE",
    ADD_IMAGE_TO_DELETE_LIST = "ADD_IMAGE_TO_DELETE_LIST",
    REMOVE_IMAGE_FROM_DELETE_LIST = "REMOVE_IMAGE_FROM_DELETE_LIST",
    CLEAR_DELETE_DATA = "CLEAR_DELETE_DATA",
    SET_CARBON_SECTION_DATA = "SET_CARBON_SECTION_DATA",
    SET_USER_TYPE = "SET_USER_TYPE",
    UPDATE_INSPECTION_REUSE_STATUS_SAVING = "UPDATE_INSPECTION_REUSE_STATUS_SAVING",
    UPDATE_INSPECTION_REUSE_STATUS_SUCCESS = "UPDATE_INSPECTION_REUSE_STATUS_SUCCESS",
    UPDATE_INSPECTION_REUSE_STATUS_FAILED = "UPDATE_INSPECTION_REUSE_STATUS_FAILED",
    UPDATE_INSPECTION_REPORT_REUSE_SAVING = "UPDATE_INSPECTION_REPORT_REUSE_SAVING",
    UPDATE_INSPECTION_REPORT_REUSE_SUCCESS = "UPDATE_INSPECTION_REPORT_REUSE_SUCCESS",
    UPDATE_INSPECTION_REPORT_REUSE_FAILED = "UPDATE_INSPECTION_REPORT_REUSE_FAILED",
    UPDATE_SECTION_EXPIRY_DATE = "UPDATE_SECTION_EXPIRY_DATE",
    SET_EXPIRY_DATE_ERROR = "SET_EXPIRY_DATE_ERROR",
    SET_SAVING_EXPIRY_DATE = "SET_SAVING_EXPIRY_DATE",
    SAVING_EXPIRY_DATE_ERROR = "SAVING_EXPIRY_DATE_ERROR",
    SAVING_EXPIRY_DATE_SUCCESS = "SAVING_EXPIRY_DATE_SUCCESS",
    UPDATE_GLOBAL_EXPIRY_DATE = "UPDATE_GLOBAL_EXPIRY_DATE",
    ASSIGN_IMAGES_TO_DEFECT_SAVING = "ASSIGN_IMAGES_TO_DEFECT_SAVING",
    ASSIGN_IMAGES_TO_DEFECT_SUCCESS = "ASSIGN_IMAGES_TO_DEFECT_SUCCESS",
    ASSIGN_IMAGES_TO_DEFECT_FAILED = "ASSIGN_IMAGES_TO_DEFECT_FAILED"
}

export { ActionTypes };
